/**
 * og:image:alt / twitter:image:alt text, shared by SEOHead.tsx and scripts/prerender-tools.mjs
 * so the runtime head and the static tool pages describe the same image the same way.
 */

/** Describes what /opengraph.jpeg actually shows (white "figtures." wordmark on black). */
const DEFAULT_IMAGE_DESCRIPTION = {
  tr: 'Figtures logosu ve “Product Studio İstanbul” yazısı',
  en: 'Figtures logo with “Product Studio Istanbul” lettering',
};

const BRAND_SUFFIX = /\s*[|–—-]\s*Figtures\s*$/i;

function normalizeLocale(locale) {
  return locale === 'tr' ? 'tr' : 'en';
}

function clean(value) {
  return typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : '';
}

/** "Backdoor Tickets | Figtures" → "Backdoor Tickets" */
export function stripBrandSuffix(title) {
  return clean(title).replace(BRAND_SUFFIX, '').trim();
}

/** Alt text for the site-wide default share image; page label keeps it page-specific. */
export function buildDefaultOgImageAlt({ locale, pageTitle, isHome = false }) {
  const lang = normalizeLocale(locale);
  const description = DEFAULT_IMAGE_DESCRIPTION[lang];
  const label = stripBrandSuffix(pageTitle);
  if (isHome || !label || label.toLowerCase() === 'figtures') return description;
  return lang === 'tr' ? `${description} — ${label} sayfası` : `${description} — ${label} page`;
}

/** Alt text for a project hero screenshot: project name + its own short summary. */
export function buildProjectOgImageAlt({ locale, projectTitle, summary }) {
  const lang = normalizeLocale(locale);
  const name = stripBrandSuffix(projectTitle);
  const text = clean(summary).replace(/\.$/, '');
  const lead = lang === 'tr' ? `${name} proje ekranı` : `${name} project screenshot`;
  return text ? `${lead}: ${text}` : lead;
}

/** Alt text for a blog post cover. */
export function buildBlogCoverOgImageAlt({ locale, postTitle }) {
  const lang = normalizeLocale(locale);
  const title = stripBrandSuffix(postTitle);
  return lang === 'tr' ? `${title} kapak görseli` : `${title} cover image`;
}

/** Alt text for the build-time templated share image, which prints the page title. */
export function buildTemplateOgImageAlt({ locale, pageTitle }) {
  const lang = normalizeLocale(locale);
  const label = stripBrandSuffix(pageTitle) || 'Figtures';
  return lang === 'tr'
    ? `Figtures paylaşım görseli: “${label}” başlığı`
    : `Figtures share image with the title “${label}”`;
}

/** Fallback when a page supplies its own image but no alt. */
export function buildCustomOgImageAlt({ locale, pageTitle }) {
  const lang = normalizeLocale(locale);
  const label = stripBrandSuffix(pageTitle) || 'Figtures';
  return lang === 'tr' ? `${label} görseli` : `${label} image`;
}
